import { BookOpen } from "lucide-react";
import { ItemCard } from "./ItemCard";
import { useLang } from "@/lib/i18n";

const PageShell = ({ no, title, children }) => {
  const { t } = useLang();
  return (
  <div className="bk-page" data-testid={`book-page-${no}`}>
    <div className="bk-page-head">
      <span>MUTONI · {t("nav.catalog")}</span>
      <span className="truncate">{title}</span>
    </div>
    <div className="bk-page-body">{children}</div>
    <div className="bk-page-foot"><span>{no}</span></div>
  </div>
  );
};

export const CoverPage = ({ total, subtitle }) => {
  const { t } = useLang();
  return (
  <div className="bk-cover" data-testid="book-cover">
    <p className="mono text-[10px] text-[#0d0c0a]/70">{t("book.edition")}</p>
    <p className="font-display mt-auto text-5xl leading-[0.9] text-[#0d0c0a] xl:text-6xl">{t("nav.catalog")}<br /><em>MUTONI</em></p>
    <p className="mt-3 text-sm text-[#0d0c0a]/80">{subtitle}</p>
    <p className="mono mt-6 text-[10px] text-[#0d0c0a]/70">{t("book.turn", { n: total })} <BookOpen size={12} className="inline" /></p>
  </div>
  );
};

export const ItemsPage = ({ no, items, onOpen }) => (
  <PageShell no={no} title={items[0]?.line || ""}>
    <div className="bk-grid">
      {items.map((it) => <ItemCard key={it.id} item={it} onOpen={onOpen} />)}
    </div>
  </PageShell>
);

export const EndPage = ({ no, empty }) => {
  const { t } = useLang();
  return (
  <PageShell no={no} title="">
    <div className="grid h-full place-items-center text-center">
      <div>
        <p className="font-display text-3xl text-[#1b1712]">{t(empty ? "book.empty" : "book.end")}</p>
        <p className="mt-2 text-sm text-[#5a5047]">{t(empty ? "book.emptyHint" : "book.growing")}</p>
      </div>
    </div>
  </PageShell>
  );
};
